<div class="page-wrapper">
    <div class="option-card">
        <div class="option-card-header">
            <span class="fas fa-file-alt"></span>
            {{ 'LEGAL.TITLE.IMPRINT' | translate }}
        </div>
        <div class="option-card-body" [innerHTML]="'LEGAL.IMPRINT.BODY' | translate"></div>
    </div>
</div>
